import { type AppId, smartlinkExtensionKeyToAppIdMap } from '@post-office/rovo-expansion-common';

/** `onedrive-object-provider` names two products, sharepoint first. */
export const resolveProviderKeyToAppIds = (providerKey: string): AppId[] => {
	// A plain object, so an inherited key like `constructor` reads a function rather than an `AppId`.
	const appIds = smartlinkExtensionKeyToAppIdMap[providerKey];

	if (Array.isArray(appIds)) {
		return [...appIds];
	}

	return typeof appIds === 'string' ? [appIds] : [];
};

export const resolveProviderKeyToAppId = (providerKey: string): AppId | undefined =>
	resolveProviderKeyToAppIds(providerKey)[0];
